<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Work Order"
    size="lg"
    @on-hide="resetFormData"
  >
    <work-orders-form
      v-bind="value"
      @on-submit="updateWorkOrder"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import WorkOrdersForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'WorkOrdersEditModal',
  mixins: [formModalMixin],
  components: {
    WorkOrdersForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: 'work-order-edit-modal',
    };
  },
  methods: {
    updateWorkOrder(data, handleUpdate) {
      handleUpdate(this.$workOrdersAPI.update(this.$route.params.id, data));
    },
    onSave(workOrder) {
      this.closeModal();
      this.$emit('input', workOrder);
    },
  },
};
</script>
